<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{dialogTitle}}</h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <form [formGroup]="memberForm">

            <div class="mb-24" fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field fxFlex>
                    <input type="text" matInput data-test="FI-Personen durchsuchen..." formControlName="member"
                           [placeholder]="'dialogs.pick.searchPersonsPlaceholder' | translate"
                           [matAutocomplete]="addressSelector">
                    <mat-error>{{memberForm.get('member').errors | firstErrorMessage}}</mat-error>
                </mat-form-field>
            </div>

            <mat-autocomplete #addressSelector="matAutocomplete" [displayWith]="displayMemberWith">
                <mat-option *ngFor="let member of (filteredMembers$ | async)" [value]="member">
                    <span>{{ member.firstName }} {{ member.lastName }}</span>
                </mat-option>
            </mat-autocomplete>

            <ng-container *ngIf="includeKinshipFields">
                <div>
                    <mat-form-field appearance="outline" fxFlex="20">
                        <mat-label>{{ 'dialogs.pick.kinshipPrefixLabel' | translate }}</mat-label>
                        <mat-select data-test="FS-Prefix" formControlName="kinshipDegreePrefix" #prefixField>
                            <mat-option [value]="'Groß-'">{{ 'dialogs.pick.kinshipPrefix.gross' | translate }}</mat-option>
                            <mat-option [value]="'Ur-'">{{ 'dialogs.pick.kinshipPrefix.ur' | translate }}</mat-option>
                            <mat-option [value]="'Enkel-'">{{ 'dialogs.pick.kinshipPrefix.enkel' | translate }}</mat-option>
                            <mat-option [value]="'Halb-'">{{ 'dialogs.pick.kinshipPrefix.halb' | translate }}</mat-option>
                            <mat-option [value]="'Adoptiv-'">{{ 'dialogs.pick.kinshipPrefix.adoptiv' | translate }}</mat-option>
                            <mat-option [value]="'Wahl-'">{{ 'dialogs.pick.kinshipPrefix.wahl' | translate }}</mat-option>
                            <mat-option [value]="'Schwieger-'">{{ 'dialogs.pick.kinshipPrefix.schwieger' | translate }}</mat-option>
                            <mat-option [value]="'Stief-'">{{ 'dialogs.pick.kinshipPrefix.stief' | translate }}</mat-option>
                        </mat-select>
                        <mat-error>{{memberForm.get('kinshipDegreePrefix').errors | firstErrorMessage}}</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="80">
                        <mat-label>{{ 'dialogs.pick.kinshipDegreeLabel' | translate }}</mat-label>
                        <mat-select data-test="FS-Verwandschaftsgrad" formControlName="kinshipDegree">
                            <mat-option [value]="'Vater'">{{ 'dialogs.pick.kinshipDegree.father' | translate }}</mat-option>
                            <mat-option [value]="'Mutter'">{{ 'dialogs.pick.kinshipDegree.mother' | translate }}</mat-option>
                            <mat-option [value]="'Kind'">{{ 'dialogs.pick.kinshipDegree.child' | translate }}</mat-option>
                            <mat-option [value]="'Sohn'">{{ 'dialogs.pick.kinshipDegree.son' | translate }}</mat-option>
                            <mat-option [value]="'Tochter'">{{ 'dialogs.pick.kinshipDegree.daughter' | translate }}</mat-option>
                            <mat-option [value]="'Enkel'">{{ 'dialogs.pick.kinshipDegree.grandson' | translate }}</mat-option>
                            <mat-option [value]="'Enkelin'">{{ 'dialogs.pick.kinshipDegree.granddaughter' | translate }}</mat-option>
                            <mat-option [value]="'Neffe'">{{ 'dialogs.pick.kinshipDegree.nephew' | translate }}</mat-option>
                            <mat-option [value]="'Nichte'">{{ 'dialogs.pick.kinshipDegree.niece' | translate }}</mat-option>
                            <mat-option [value]="'Onkel'">{{ 'dialogs.pick.kinshipDegree.uncle' | translate }}</mat-option>
                            <mat-option [value]="'Tante'">{{ 'dialogs.pick.kinshipDegree.aunt' | translate }}</mat-option>
                            <mat-option [value]="'Cousin'">{{ 'dialogs.pick.kinshipDegree.cousinM' | translate }}</mat-option>
                            <mat-option [value]="'Cousine'">{{ 'dialogs.pick.kinshipDegree.cousinF' | translate }}</mat-option>
                            <mat-option [value]="'Ehe- / Lebenspartner'">{{ 'dialogs.pick.kinshipDegree.partner' | translate }}</mat-option>
                        </mat-select>
                        <mat-error>{{memberForm.get('kinshipDegree').errors | firstErrorMessage}}</mat-error>
                    </mat-form-field>
                </div>

                <u2b-message>
                    {{ 'dialogs.pick.kinshipHintBefore' | translate }}<strong>{{ 'dialogs.pick.kinshipHintExample' | translate }}</strong>{{ 'dialogs.pick.kinshipHintMiddle' | translate }}
                    <a class="mat-primary" href="javascript:void(0)" (click)="prefixField.focus()">{{ 'dialogs.pick.kinshipPrefixLink' | translate }}</a>{{ 'dialogs.pick.kinshipHintAfter' | translate }}
                </u2b-message>
            </ng-container>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button data-test="B-Speichern" mat-flat-button
                (click)="save()"
                class="save-button mat-accent"
                [disabled]="isSaving || !memberForm.dirty"
                [attr.aria-label]="'common.save' | translate">
            {{ 'common.save' | translate }}
        </button>

    </div>
</div>
